export default {
      id: "reports-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "img/icons.adde2a28.svg#reports",
      toString: function () {
        return this.url;
      }
    }